export const footerHeight = "80px";
